import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import { scroller } from "react-scroll";
import { animated } from "react-spring";

export default function DataComparison() {
    const handleButtonClick = () => {
        scroller.scrollTo("waitlist", {
          duration: 1000,
          delay: 0,
          smooth: true,
          offset: 100,
        });
      };
    return (
      <section className="relative bg-[#292936] text-white py-20 px-6 md:px-12 lg:px-20">
        <div
        className="absolute inset-0  left-[20%] animate-spin-slow"
        style={{
          backgroundImage:
            "url('/static/data-comparison/bg.svg')", // put your repeated icons image here
          backgroundRepeat: "no-repeat",
         
        }}
      ></div>
        {/* Title */}
        <div className="text-center max-w-5/6 mx-auto relative z-0">
          <h2 className="!text-3xl md:!text-[45px] !font-bold">
            View Your Unseen Data
          </h2>
          <p className="mt-4 text-[#9d9dbb] md:!text-lg !text-base">
            Discover the hidden insights in your game data – we transform basic
            events into comprehensive, actionable intelligence that reveals what
            your players really do.
          </p>
         {/* Button */}
         <animated.div >
        <Button
            variant="contained"
            size="large"
            endIcon={
              <FontAwesomeIcon icon={faCaretRight} height={8} width={6} />
            }
            onClick={handleButtonClick}
            className="
              cursor-pointer rounded-lg border-none !bg-[#00DDDD] !mt-8
              px-6 py-3 text-white hover:!text-[#00DDDD] font-medium shadow-md hover:!bg-[#fff]
            "
          >
            Sign up
          </Button>
        </animated.div>
        </div>
  
        {/* Comparison Cards */}
        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-12 relative z-0">
          {/* Without POGR */}
          {/* <div className="bg-[#1f2937] border-2 border-red-500 rounded-xl shadow-lg max-w-sm w-full p-4">
            <h3 className="text-lg font-bold">Without POGR</h3>
            <p className="text-red-400 text-sm mb-4">Simple game events</p>
            <div className="bg-[#111827] rounded-md p-3 font-mono text-gray-300 text-sm">
              &lt;AI&gt; damages &lt;Player&gt;
            </div>
          </div> */}
          <img src="/static/data-comparison/poger-left.svg" alt="" />
  
          {/* Arrow */}
          <div className="text-teal-400 text-5xl font-bold hidden md:block">
           <img src="/static/data-comparison/arrow-icon.svg" alt="" />
          </div>
  
          {/* With POGR */}
          <img src="/static/data-comparison/poger-right.svg" alt="" />
        </div>
      </section>
    );
  }
  